import { render } from "./taskPage.vue?vue&type=template&id=93bf10dc&ts=true"
import script from "./taskPage.vue?vue&type=script&lang=ts"
export * from "./taskPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__